import Head from "next/head";
import React from "react";



const Signup = () => {
  return (
    <>
      <Head>
        <title>Olivela | Sign up</title>
        <meta name="title" content="Olivela | Sign up" />
        <meta name="description" content="Shop luxury fashion, beauty & lifestyle pieces at Olivela where 20% of proceeds from every purchase supports causes you care about." />
        <meta property="og:title" content="Olivela | Sign up"></meta>
        <meta property="og:description" content="Shop luxury fashion, beauty & lifestyle pieces at Olivela where 20% of proceeds from every purchase supports causes you care about."></meta>
        <meta property="og:url" content={`${process.env.NETLIFY_URL}/sign-up`}></meta>
        <meta
          property="og:image"
          content={`${process.env.NETLIFY_URL}/${process.env.OG_IMAGE_PATH}`}
        ></meta>
        <meta
          property="og:image:secure_url"
          content={`${process.env.NETLIFY_URL}/${process.env.OG_IMAGE_PATH}`}
        ></meta>
        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="628"></meta>
      </Head>
     
      <iframe src="https://olivela.attn.tv/p/XYm/Olivela" width="100%" height="100%" style={{ minHeight: '800px' }}></iframe>
      <div class="nosto_element" id="sign-up-page"></div>
    </>
  );
};

export default Signup;